import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    windheight: '',
    HomeNum:'',
    paId: localStorage.getItem('paId') ? localStorage.getItem('paId') : '',
    paAccount: localStorage.getItem('paAccount') ? localStorage.getItem('paAccount') : '',
    paName: localStorage.getItem('paName') ? localStorage.getItem('paName') : '',
  },
  mutations: {
    changeuser(state, user) {
      state.paId = user.paId.paId;
      state.username = user.paId.paAccount;
      state.paName = user.paId.paName;
      state.paPost = user.paId.paPost;
      localStorage.setItem('paId', user.paId.paId);
      localStorage.setItem('paAccount', user.paId.paAccount);
      localStorage.setItem('paName', user.paId.paName);

    },
    getWindowHeight(state, data) {
      state.windheight = data.windheight;
    },
    getHomeNum(state, data) {
      console.log(data);
      state.HomeNum = data.HomeNum;
    }
  },
  actions: {
  },
  modules: {
  }
})
